angular.module('gym.components').directive('contactImageUploader', ["$timeout", "flash", function($timeout, flash) {
  return {
    restrict: 'EA',
    template: require('templates/components/contactImageUploader.html.slim'),
    scope: {
      contact: '='
    },
    link: function($scope) {
      $scope.id = Math.floor(Math.random() * 10000);
      $scope.selectImage = function() {
        angular.element(`#contact-image-uploader-${$scope.id}`).click();
        return true;
      };
      if (!$scope.imageData && $scope.contact.image) {
        $scope.imageData = {
          imagePreview: `data:image/png;base64,${$scope.contact.image}`
        };
      }
      return $scope.$watch('imageData.file', function(file) {
        var dataUrlReader;
        if (file != null ? file.size : void 0) {
          if (file.size > 5000000) {
            flash.error = 'Image size must be 5MB or lower';
            return;
          }
          dataUrlReader = new window.FileReader();
          dataUrlReader.readAsDataURL(file);
          return dataUrlReader.onloadend = function() {
            return $timeout(function() {
              $scope.imageData.imagePreview = dataUrlReader.result;
              return $scope.contact.image = dataUrlReader.result.replace(/^data:image\/\w*;base64,/, '');
            });
          };
        }
      });
    }
  };
}]);
